import { BasicDurations } from "app/services/DurationService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export type DateRangeMode = "default" | "PoP" | "YoY";

export const resolveDateRangeMode = (): DateRangeMode | null => {
    const params = proNavigator.getParams();
    const { comparedDuration, duration } = params;
    if (!duration) {
        return null;
    }
    if (!comparedDuration) {
        return "default";
    }
    return comparedDuration === BasicDurations.LAST_TWELVE_MONTHS ? "YoY" : "PoP";
};
